function convertData(data) {
  const tempData = [];
  data.forEach(item => {
    if (item.subordinateChannels && item.subordinateChannels.length > 0) {
      const tempItemData = [];
      item.subordinateChannels.forEach(ele => {
        tempItemData.push({ ...ele, value: ele.id, label: ele.name });
      });
      tempData.push({
        ...item,
        value: item.id,
        label: item.name,
        children: tempItemData,
      });
    } else {
      tempData.push({ ...item, value: item.id, label: item.name, children: [] });
    }
  });
  return tempData;
}

function getDefaultData(data, id) {
  const tempData = [];
  data.forEach(item => {
    if (id === item.id) {
      tempData.push(item.id);
    } else if (item.subordinateChannels && item.subordinateChannels.length > 0) {
      item.subordinateChannels.forEach(ele => {
        if (ele.id === id) {
          tempData.push(item.id);
          tempData.push(ele.id);
        }
      });
    }
  });
  return tempData;
}

function getLabelStrData(data, alreadyPushList) {
  const tempArr = [];
  (data.content || []).forEach(item => {
    const tempStrArr = [];
    if (item.labelList && item.labelList.length > 0) {
      item.labelList.forEach(ele => {
        tempStrArr.push(ele.label);
      });
    }
    tempArr.push({
      ...item,
      labelData: tempStrArr,
      disabled: alreadyPushList && !!alreadyPushList[item.id],
    });
  });
  return tempArr;
}

function getStarNumber(data) {
  const score = Number(data);
  let starArr = [];
  if (score >= 91) {
    starArr = ['full', 'full', 'full', 'full', 'full'];
  }
  if (score >= 81 && score <= 90) {
    starArr = ['full', 'full', 'full', 'full', 'half'];
  }
  if (score >= 71 && score <= 80) {
    starArr = ['full', 'full', 'full', 'full'];
  }
  if (score >= 61 && score <= 70) {
    starArr = ['full', 'full', 'full', 'half'];
  }
  if (score >= 51 && score <= 60) {
    starArr = ['full', 'full', 'full'];
  }
  if (score >= 41 && score <= 50) {
    starArr = ['full', 'full', 'half'];
  }
  if (score >= 31 && score <= 40) {
    starArr = ['full', 'full'];
  }
  if (score >= 21 && score <= 30) {
    starArr = ['full', 'half'];
  }
  if (score >= 11 && score <= 20) {
    starArr = ['full'];
  }
  if (score >= 1 && score <= 10) {
    starArr = ['half'];
  }
  if (score < 1) {
    starArr = ['zero'];
  }
  return starArr;
}

export { convertData, getDefaultData, getLabelStrData, getStarNumber };
